import * as yup from "yup";

export const sponsorContactSchema = yup.object().shape({
  sponsor_contact_name: yup.string(),
  sponsor_contact_email: yup.string().email("Invalid email format"),
  sponsor_contact_phone: yup
    .string()
    .matches(/^\d{3}-\d{3}-\d{3}-\d{1}$/, "Phone number must be in the format 123-456-789-0"),
});
